import { Table } from '@mui/material'

import EventsTableBody from '@/components/Table/EventsTable/EventsTableBody'
import BackofficeTableContainer from '@/components/Table/Generic/BackofficeTableContainer/BackofficeTableContainer'
import BackofficeTablePagination from '@/components/Table/Generic/BackofficeTablePagination/BackofficeTablePagination'
import TableHeader from '@/components/Table/Generic/TableHeader/TableHeader'
import { BackofficeTableStyle } from '@/utils/customStyle/tableStyle'
import { columns } from '@/utils/tableColumns/eventsTable'

const EventsTable = ({
  data,
  loading = false,
  onPaginationChange = () => {},
  filter = {},
  onSortChange = () => {},
  sort = { column: '', order: '' }
}) => {
  return (
    <>
      <BackofficeTableStyle />
      <div style={{ width: '100%', overflowX: 'auto' }}>
        <BackofficeTableContainer columns={columns} loading={loading}>
          <Table
            aria-label="Tabela de eventos"
            size="medium"
            style={{
              tableLayout: 'fixed',
              width: '100%',
              minWidth: '800px'
            }}
          >
            <TableHeader columns={columns} onSort={onSortChange} sort={sort} />
            <EventsTableBody data={data} />
          </Table>
        </BackofficeTableContainer>
      </div>
      <BackofficeTablePagination filter={filter} onPaginationChange={onPaginationChange} total={data?.total} />
    </>
  )
}

export default EventsTable
